const source = 'pdrsDataTable'

function downloadMultipdrsPdf () {

  const keys = Object.keys(this.filtered.items).filter((s) => s == source)
  if(keys.length > 0){
    const ids = this.filtered.items[source]

    this.$eventBus.emit('show-dialog-page', {
      page: 'pdrs-multipdrs',
      title: 'Multipdrs',
      data: ids,
      maximize: false,
    })
  } 
}

export default {
  'bindTo': 'this',
  'method': downloadMultipdrsPdf,
}
